
import React from 'react';
import { Link } from 'react-router-dom';
import { useMobileNavigationItemHandlers } from './useMobileNavigationItemHandlers';
import { 
  Globe, 
  AppWindow, 
  ShoppingCart, 
  Brain,
  ArrowRight 
} from 'lucide-react';

const mobileProducts = [
  {
    name: 'All Products',
    icon: Globe,
    href: '/products',
  },
  {
    name: 'E-Commerce',
    icon: ShoppingCart,
    href: '/products/enterprise-ecommerce-platform',
  },
  {
    name: 'Websites & Web Apps',
    icon: AppWindow,
    href: '/products/website-webapp-suite',
  },
  {
    name: 'Artificial Intelligence',
    icon: Brain,
    href: '/ai-agents',
  },
];

interface MobileProductMenuProps {
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const MobileProductMenu: React.FC<MobileProductMenuProps> = ({ onClose, onNavigationClick }) => {
  const { handleClick } = useMobileNavigationItemHandlers({
    onNavigationClick,
    onClose
  });
  return (
    <div className="pl-4 space-y-2">
      {mobileProducts.map((product) => (
        <Link
          key={product.href}
          to={product.href}
          onClick={(e) => handleClick(product.href, e)}
          className="flex items-center gap-3 px-2 py-3 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition-colors"
          style={{ minHeight: 48, minWidth: 48, touchAction: 'manipulation' }}
          role="menuitem"
          tabIndex={0}
        >
          <product.icon className="h-5 w-5 text-gray-500" />
          <span>{product.name}</span>
        </Link>
      ))}
      
      {/* View All Products Link */}
      <Link
        to="/products"
        onClick={(e) => handleClick('/products', e)}
        className="flex items-center gap-3 px-2 py-3 rounded-md text-base font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors border-t border-gray-200 mt-3 pt-3"
        style={{ minHeight: 48, minWidth: 48, touchAction: 'manipulation' }}
        role="menuitem"
        tabIndex={0}
      >
        <ArrowRight className="h-5 w-5" />
        <span>View All Products</span>
      </Link>
    </div>
  );
};
